import Alert from '@mui/material/Alert';
import LinearProgress from '@mui/material/LinearProgress';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useParams } from 'react-router-dom';

import { collectionQuery, HOME } from './collection';

/**
 * Where an old publish link goes, now that every kind has a screen of its own — GEN-60.
 *
 * By kind rather than straight to the module: `/authoring/collections/:id/publish` served
 * courses, modules and paths, so sending every id to `/library/modules/:id` would render
 * a path as a module. The id in the path is the id the destination wants, so the only
 * question is which of the three homes, and the row is what answers it.
 *
 * A screen rather than an element written into the route table, because it has a screen's
 * states: an id that resolves to nothing is a different thing from one still loading, and
 * a redirect that spun forever on a deleted collection would look like a hang.
 */
export function ToCollection() {
  const { id = '' } = useParams<{ id: string }>();
  const row = useQuery(collectionQuery(id));

  if (row.isPending) return <LinearProgress />;

  const found = row.data?.data;

  if (found === undefined)
    return <Alert severity="error">No collection with that id.</Alert>;

  return <Navigate replace to={`${HOME[found.kind]}/${id}`} />;
}
